import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titleExtractor',
  standalone: true,
})
export class TitleExtractorPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const parts = value.split('|').map((part) => part.trim());
    switch (parts.length) {
      case 5: // Optimal
        return parts[1] + ' ' + parts[2];
      case 4: // Suboptimal+
        return parts[1] + ' ' + parts[2];
      case 3: // Suboptimal
        return parts[1] + ' ' + parts[2];
      case 2: //  Suboptimal Accessory
        return parts[1];
      case 1: // Basic
        return parts[0];
      default:
        return '';
    }
  }
}
